module.exports = __webpack_public_path__ + "media/images/vp/icon.trend.down-2edabcf28dd122314c6636707a4f6d71.svg";